import { Alert, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNotificationStore } from '@/app/notificationStore';

/**
 * Renders queued toasts one at a time, oldest first, so a burst of WebSocket events does
 * not stack a wall of alerts over the page.
 */
export default function NotificationHost() {
  const { t } = useTranslation();
  const items = useNotificationStore((state) => state.items);
  const dismiss = useNotificationStore((state) => state.dismiss);

  const current = items[0];
  if (!current) return null;

  const text = current.messageKey
    ? t(current.messageKey, current.values ?? {})
    : (current.message ?? '');

  return (
    <Snackbar
      open
      autoHideDuration={5000}
      onClose={() => dismiss(current.id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity={current.severity}
        variant="filled"
        onClose={() => dismiss(current.id)}
        className="min-w-[280px]"
      >
        {text}
      </Alert>
    </Snackbar>
  );
}
